<section class="company-profile-hero" [attr.aria-labelledby]="headingId">
  <div class="company-profile-hero__map" [class.company-profile-hero__map--unavailable]="!coordinates" aria-label="Registered company location">
    @if (coordinates; as point) {
      <company-location-map
        [latitude]="point[0]"
        [longitude]="point[1]"
        [zoom]="zoom"
        [showMarker]="showMarker"
        [markerRadius]="9"
        [markerFill]="markerFill"
        markerStroke="white"
        [markerStrokeWidth]="3">
      </company-location-map>
      <span class="company-profile-hero__map-label"><i class="fal fa-location-dot" aria-hidden="true"></i> {{ mapLabel }}</span>
    } @else {
      <span class="company-profile-hero__map-pin" aria-hidden="true"><i class="fal fa-location-dot"></i></span>
      <span class="company-profile-hero__map-label"><i class="fal fa-location-dot" aria-hidden="true"></i> {{ mapUnavailableLabel }}</span>
    }
  </div>
  <div class="company-profile-hero__body">
    <div class="company-profile-hero__primary">
      <ng-content select="[heroBadge]"></ng-content>
      <div class="company-profile-hero__identity">
        <span class="company-profile-hero__logo" [class.company-profile-hero__logo--fallback]="!logoSrc" aria-hidden="true">@if (logoSrc) {<img #logo [src]="logoSrc" (load)="onLogoLoad(logo)" (error)="logoFailed = true" alt="" />} @else {<i [class]="logoFallbackIconClass"></i>}</span>
        <div class="company-profile-hero__identity-text">
          @if (eyebrow) {<span class="company-profile-hero__eyebrow">{{ eyebrow }}</span>}
          <h1 [id]="headingId"><ng-content select="[heroNamePrefix]"></ng-content><span class="company-profile-hero__name">{{ name }}</span></h1>
          <div class="company-profile-hero__meta"><ng-content select="[heroMeta]"></ng-content></div>
        </div>
      </div>
      <ng-content></ng-content>
    </div>
    <ng-content select="[heroAside]"></ng-content>
  </div>
</section>
